module.exports = __webpack_public_path__ + "img/massive-sent.d1a8aaea.png";